// eslint-disable-next-line @typescript-eslint/no-empty-interface
import {
  ACTION_COMPLETE_PRICING_UPLOAD,
  ACTION_DOWNLOAD_PRICING,
  ACTION_DOWNLOAD_PRICING_STARTED,
  ACTION_LOAD_PRICING,
  ACTION_PRICING_LOADED,
  ACTION_PRICING_SAVED,
  ACTION_SAVE_PRICING,
  ACTION_UPLOAD_PRICING,
  ACTION_UPLOAD_PRICING_FAILED,
  ACTION_UPLOAD_PRICING_SUCCEEDED,
} from "./constants";
import { Pricing } from "./Pricing";

export interface LoadPricingAction {
  type: typeof ACTION_LOAD_PRICING;
}

export function loadPricing(): LoadPricingAction {
  return {
    type: ACTION_LOAD_PRICING,
  };
}

export interface PricingLoadedAction {
  type: typeof ACTION_PRICING_LOADED;
  pricingItems: Array<Pricing>;
}

export function pricingLoaded(
  pricingItems: Array<Pricing>
): PricingLoadedAction {
  return {
    type: ACTION_PRICING_LOADED,
    pricingItems: pricingItems,
  };
}

export interface UploadPricingAction {
  type: typeof ACTION_UPLOAD_PRICING;
  content: File;
}

export interface PricingUploadSucceededAction {
  type: typeof ACTION_UPLOAD_PRICING_SUCCEEDED;
  pricingItems: Array<Pricing>;
  pricingImportId: string;
}

export interface PricingUploadFailedAction {
  type: typeof ACTION_UPLOAD_PRICING_FAILED;
  errors: Array<string>;
}

export interface CompletePricingUploadAction {
  type: typeof ACTION_COMPLETE_PRICING_UPLOAD;
}

export interface SavePricingAction {
  type: typeof ACTION_SAVE_PRICING;
  pricingImportId: string;
}

export interface PricingSavedAction {
  type: typeof ACTION_PRICING_SAVED;
}

export interface DownloadPricingAction {
  type: typeof ACTION_DOWNLOAD_PRICING;
}

export interface DownloadPricingStartedAction {
  type: typeof ACTION_DOWNLOAD_PRICING_STARTED;
}

export function uploadPricing(content: File): UploadPricingAction {
  return {
    type: ACTION_UPLOAD_PRICING,
    content: content,
  };
}

export function pricingUploadSucceeded(
  pricingItems: Array<Pricing>,
  pricingImportId: string
): PricingUploadSucceededAction {
  return {
    type: ACTION_UPLOAD_PRICING_SUCCEEDED,
    pricingItems: pricingItems,
    pricingImportId: pricingImportId,
  };
}

export function pricingUploadFailed(
  errors: Array<string>
): PricingUploadFailedAction {
  return {
    type: ACTION_UPLOAD_PRICING_FAILED,
    errors: errors,
  };
}

export function savePricing(pricingImportId: string): SavePricingAction {
  return {
    type: ACTION_SAVE_PRICING,
    pricingImportId: pricingImportId,
  };
}

export function completePricingUpload(): CompletePricingUploadAction {
  return {
    type: ACTION_COMPLETE_PRICING_UPLOAD,
  };
}

export function pricingSaved(): PricingSavedAction {
  return {
    type: ACTION_PRICING_SAVED,
  };
}

export function downloadPricing(): DownloadPricingAction {
  return {
    type: ACTION_DOWNLOAD_PRICING,
  };
}

export function downloadPricingStarted(): DownloadPricingStartedAction {
  return {
    type: ACTION_DOWNLOAD_PRICING_STARTED,
  };
}
